import LoginWelcome from '../../components/Login/Login';

export function Login() {
  return <LoginWelcome />;
}
